import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  display: flex;
  height: 350px;
  margin-bottom: 80px;
  justify-content: space-between;

  div:last-child {
    margin-left: 13px;
    margin-right: 3px;
  }

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const Square = styled.div`
  width: 49.1%;
  height: 100%;
  margin-right: 13px;
  border-radius: 20px;
  background: linear-gradient(#dfedee, #ffffff);
`;

export const SquareCarousel = styled.div`
  height: 100%;
  width: 300px;
  border-radius: 20px;
  background: linear-gradient(#f3f4f8, #ffffff);
`;

export const ContentWrapper = styled.div`
  height: 350px;
  display: flex;
  width: 1245px;
  position: absolute;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const Title = styled.p`
  font-size: 24px;
  max-width: 673px;
  line-height: 29px;
  text-align: center;
  margin-bottom: 46px;
`;

export const ButtonWrapper = styled.div`
  display: flex;

  button:first-of-type {
    color: black;
    border: 1.5px solid #5fa3a9;
    background-color: transparent;
  }

  button:last-child {
    margin-left: 22px;
  }
`;
